import React from 'react'
import { appSelectors, useAppStore } from '@/store'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'

export const Message: React.FC<{ isInline?: boolean }> = ({ isInline }) => {
  const actions = useAppStore(appSelectors.actions)
  const message = useAppStore(appSelectors.message)
  const t = useTranslations()

  React.useEffect(() => {
    if (!!message && message?.hideInterval) {
      setTimeout(() => {
        actions.setMessage(undefined)
      }, message.hideInterval)
    }
  }, [message, actions])

  return message ? (
    <motion.div
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ ease: 'easeOut', duration: 0.2 }}
      className={cn(
        'message w-full clear bg-red px-6 py-3 text-center text-white margin-b-6 top-0 left-0 right-0 z-[99999]',
        isInline ? 'fixed py-5' : 'absolute py-5',
        message.severity,
      )}
      onClick={() => actions.setMessage(undefined)}
    >
      {message?.tranlateNS
        ? t(`${message.tranlateNS}.${message.message}`)
        : message.message}
    </motion.div>
  ) : null
}
